import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, HelpCircleIcon, FolderIcon, BookOpenIcon, BarChartIcon, CalendarIcon, MessageSquareIcon, MessageCircleIcon, UserIcon, BellIcon, XIcon, MenuIcon, LogOutIcon, SettingsIcon, ChevronDownIcon } from 'lucide-react';
import { useUser } from './UserContext';
import { LogoutConfirmModal } from './modals/LogoutConfirmModal';
const navItems = [{
  path: '/',
  label: 'Ana Sayfa',
  icon: <HomeIcon size={20} data-id="element-1175" />
}, {
  path: '/homework',
  label: 'Ödev Takibi',
  icon: <BookOpenIcon size={20} data-id="element-1176" />
}, {
  path: '/reports',
  label: 'Raporlar ve Analizler',
  icon: <BarChartIcon size={20} data-id="element-1177" />
}, {
  path: '/forum',
  label: 'Forum',
  icon: <MessageSquareIcon size={20} data-id="element-1178" />
}, {
  path: '/messages',
  label: 'Mesajlar',
  icon: <MessageCircleIcon size={20} data-id="element-1179" />
}, {
  path: '/profile',
  label: 'Profil ve Ayarlar',
  icon: <UserIcon size={20} data-id="element-1180" />
}];
const Layout = ({
  children
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    profileImage,
    userData
  } = useUser();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const notifications = [{
    id: 1,
    text: 'Yeni öğrenci mesajı: Ahmet Yılmaz',
    time: '10 dk önce'
  }, {
    id: 2,
    text: '11-A sınıfı ödev teslim tarihi bugün',
    time: '1 saat önce'
  }, {
    id: 3,
    text: 'Veli toplantısı hatırlatması: Yarın 15:00',
    time: '3 saat önce'
  }];
  const handleNavigation = path => {
    navigate(path);
    setSidebarOpen(false); // Close sidebar on navigation (mobile)
    setShowProfileMenu(false); // Close profile menu if open
    setShowNotifications(false); // Close notifications if open
  };
  // Assume user is male for this example
  const isMale = true;
  const honorific = isMale ? 'Bey' : 'Hanım';
  return <div className="flex flex-col h-screen bg-black text-white overflow-hidden" data-id="element-1181">
      {/* Header - no bottom border */}
      <header className="h-32 px-4 md:px-6 lg:px-8 flex items-center justify-between" data-id="element-1182">
        <div className="flex items-center" data-id="element-1183">
          {/* Mobile menu button - ONLY VISIBLE ON MOBILE */}
          <button className="mr-4 h-10 w-10 rounded-full bg-gray-900 hover:bg-gray-800 flex items-center justify-center md:hidden" onClick={() => setSidebarOpen(!sidebarOpen)} data-id="element-1184">
            <MenuIcon className="text-emerald-400" size={24} data-id="element-1185" />
          </button>
          <h1 className="text-xl md:text-2xl font-bold" data-id="element-1186">
            Hoş geldin,{' '}
            <span className="text-emerald-400" data-id="element-1187">
              {userData.name.split(' ')[0]} {honorific}
            </span>
          </h1>
        </div>
        <div className="flex items-center space-x-3 md:space-x-6" data-id="element-1188">
          {/* Bell notification icon - INCREASED SIZE */}
          <div className="relative" data-id="element-1189">
            <button onClick={() => {
            setShowNotifications(!showNotifications);
            setShowProfileMenu(false);
          }} className="relative flex items-center justify-center h-12 w-12 rounded-full bg-black border border-emerald-500/30 hover:border-emerald-500/50 shadow-[0_0_10px_rgba(16,185,129,0.2)] backdrop-blur-sm transition-all duration-300" data-id="element-1190">
              <BellIcon className="text-emerald-400" size={28} data-id="element-1191" />
              {/* Notification badge */}
              <div className="absolute -top-1 -right-1 bg-emerald-500 text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium shadow-[0_0_5px_rgba(16,185,129,0.3)]" data-id="element-1192">
                <span className="text-black font-bold text-xs" data-id="element-1193">3</span>
              </div>
            </button>
            {showNotifications && <div className="absolute right-0 mt-2 w-72 md:w-80 z-50 overflow-hidden" data-id="element-1194">
                <div className="floating-card overflow-hidden border border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.2)]" data-id="element-1195">
                  <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-1196">
                    <h3 className="font-medium text-emerald-400" data-id="element-1197">
                      Bildirimler
                    </h3>
                    <div className="flex items-center gap-2" data-id="element-1198">
                      <button onClick={() => handleNavigation('/notifications')} className="text-xs text-emerald-400 hover:text-emerald-300 font-medium" data-id="element-1199">
                        Tümünü Gör
                      </button>
                      <button onClick={() => setShowNotifications(false)} className="text-gray-400 hover:text-white" data-id="element-1200">
                        <XIcon size={18} data-id="element-1201" />
                      </button>
                    </div>
                  </div>
                  <div className="max-h-96 overflow-y-auto" data-id="element-1202">
                    {notifications.map(notification => <div key={notification.id} className="p-4 border-b border-gray-800 hover:bg-gray-800/50 cursor-pointer transition-colors duration-200" data-id="element-1203">
                        <p className="text-sm" data-id="element-1204">{notification.text}</p>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-1205">
                          {notification.time}
                        </p>
                      </div>)}
                  </div>
                  <div className="p-3 text-center" data-id="element-1206">
                    <button className="text-sm text-emerald-400 hover:text-emerald-300 font-medium" onClick={() => handleNavigation('/notifications')} data-id="element-1207">
                      Tüm bildirimleri gör
                    </button>
                  </div>
                </div>
              </div>}
          </div>
          {/* Profile picture & dropdown - INCREASED SIZE */}
          <div className="relative" data-id="element-1208">
            <div className="h-16 w-16 rounded-full overflow-hidden cursor-pointer border border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.2)] hover:border-emerald-500/50 transition-all duration-300" onClick={() => {
            setShowProfileMenu(!showProfileMenu);
            setShowNotifications(false);
          }} data-id="element-1209">
              <img src={profileImage} alt="Öğretmen Profili" className="h-full w-full object-cover" data-id="element-1210" />
            </div>
            {/* Profile Dropdown Menu */}
            {showProfileMenu && <div className="absolute right-0 mt-2 w-64 z-50 overflow-hidden" data-id="element-1211">
                <div className="floating-card overflow-hidden border border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.2)]" data-id="element-1212">
                  <div className="p-4 border-b border-gray-800" data-id="element-1213">
                    <div className="flex items-center space-x-3" data-id="element-1214">
                      <div className="h-12 w-12 rounded-full overflow-hidden border border-emerald-500/30" data-id="element-1215">
                        <img src={profileImage} alt="Öğretmen Profili" className="h-full w-full object-cover" data-id="element-1216" />
                      </div>
                      <div data-id="element-1217">
                        <h3 className="font-medium" data-id="element-1218">{userData.name}</h3>
                        <p className="text-xs text-gray-400 mt-0.5" data-id="element-1219">
                          {userData.email}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1220">
                    <button onClick={() => handleNavigation('/profile')} className="w-full flex items-center space-x-3 p-4 hover:bg-gray-800/50 transition-colors text-left" data-id="element-1221">
                      <UserIcon size={18} className="text-emerald-400" data-id="element-1222" />
                      <span data-id="element-1223">Profilim</span>
                    </button>
                    <button onClick={() => {
                  setShowProfileMenu(false);
                  setShowLogoutModal(true);
                }} className="w-full flex items-center space-x-3 p-4 hover:bg-red-900/20 transition-colors text-red-400 hover:text-red-300 text-left" data-id="element-1224">
                      <LogOutIcon size={18} data-id="element-1225" />
                      <span data-id="element-1226">Çıkış Yap</span>
                    </button>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </header>
      <div className="flex-1 flex overflow-hidden" data-id="element-1227">
        {/* Mobile sidebar backdrop - ONLY FOR MOBILE */}
        {sidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm z-40 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-1228"></div>}
        {/* Sidebar - ALWAYS VISIBLE ON DESKTOP, FIXED WIDTH */}
        <div className={`fixed md:static inset-y-0 left-0 w-64 flex-shrink-0 transform transition-transform duration-300 ease-in-out z-50 md:z-0 md:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`} data-id="element-1229">
          <div className="sticky top-10 h-fit" data-id="element-1230">
            <div className="floating-card p-3 sm:p-4 lg:p-6 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-1231">
              <div className="flex items-center justify-between mb-4 border-b border-emerald-500/20 pb-4" data-id="element-1232">
                <div className="text-lg font-medium text-emerald-400" data-id="element-1233">
                  Öğretmen Paneli
                </div>
                <button className="text-gray-400 hover:text-white md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-1234">
                  <XIcon size={20} data-id="element-1235" />
                </button>
              </div>
              <nav className="flex-1 overflow-y-auto" data-id="element-1236">
                {navItems.map(item => <Link key={item.path} to={item.path} className={`flex items-center px-4 py-3 my-2 text-sm rounded-md transition-all duration-200 ${location.pathname === item.path ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.15)]' : 'text-gray-300 hover:bg-emerald-500/5 hover:text-emerald-400 hover:border hover:border-emerald-500/20'}`} data-id="element-1237">
                    <span className={`mr-3 ${location.pathname === item.path ? 'text-emerald-400' : ''}`} data-id="element-1238">
                      {item.icon}
                    </span>
                    {item.label}
                  </Link>)}
              </nav>
              {/* Hover animation like in dashboard cards */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out pointer-events-none" data-id="element-1239"></div>
            </div>
          </div>
        </div>
        {/* Page content - ADJUSTED FOR SIDEBAR */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-black md:ml-0" data-id="element-1240">
          {children}
        </main>
      </div>
      {/* Mobile menu button (fixed at bottom) - ONLY FOR MOBILE */}
      <div className="fixed bottom-4 right-4 md:hidden z-50" data-id="element-1241">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="h-14 w-14 rounded-full bg-black border border-emerald-500/50 shadow-[0_0_15px_rgba(16,185,129,0.3)] flex items-center justify-center" data-id="element-1242">
          {sidebarOpen ? <XIcon className="text-emerald-400" size={24} data-id="element-1243" /> : <MenuIcon className="text-emerald-400" size={24} data-id="element-1244" />}
        </button>
      </div>
      {/* Logout Modal */}
      <LogoutConfirmModal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} data-id="element-1245" />
    </div>;
};
export default Layout;